module.exports = __webpack_public_path__ + "img/share_logo.cd5e6b31.png";